module.exports = __webpack_public_path__ + "assets/img/1809_2.jpg?bd0fc123ecdefe63c1df53740cd99d76";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1809_2.jpg
// module id = 1130
// module chunks = 0